"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = RadioGroup;
const is_not_nil_1 = require("@uxf/core/utils/is-not-nil");
const radio_group_1 = require("@uxf/ui/radio-group");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const form_id_context_1 = require("../form-id-context");
function RadioGroup(props) {
    var _a, _b, _c, _d;
    const formId = (0, form_id_context_1.useFormIdContext)();
    const id = (_a = props.id) !== null && _a !== void 0 ? _a : `${formId}__${props.name}`;
    const { field, fieldState } = (0, react_hook_form_1.useController)({
        control: props.control,
        name: props.name,
        rules: {
            required: props.isRequired ? props.requiredMessage || "Toto pole je povinné" : undefined,
            ...props.rules,
        },
        shouldUnregister: props.shouldUnregister,
    });
    const onBlur = (event) => {
        var _a;
        field.onBlur();
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    const onChange = (value, event) => {
        var _a;
        field.onChange(value);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value, event);
    };
    return (react_1.default.createElement(radio_group_1.RadioGroup, { className: props.className, forceColumn: props.forceColumn, helperText: (_c = (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : props.helperText, hiddenLabel: props.hiddenLabel, id: id, isDisabled: props.options.length === 0 || props.isDisabled, isInvalid: (0, is_not_nil_1.isNotNil)(fieldState.error), isReadOnly: props.isReadOnly, isRequired: props.isRequired, label: props.label, name: field.name, onBlur: onBlur, onChange: onChange, onFocus: props.onFocus, options: props.options, radioSize: props.radioSize, ref: field.ref, style: props.style, value: (_d = field.value) !== null && _d !== void 0 ? _d : null, variant: props.variant }));
}
RadioGroup.displayName = "UxfFormRadioGroup";
